export default __webpack_public_path__ + "static/media/tablet_background_land.dde246cb.png";